module.exports = __webpack_public_path__ + "img/package-request-fail.561737a5.svg";